export var formatNumber = function (number, locales, fallback, options) {
  if (locales === void 0) {
    locales = 'en-US';
  }
  if (fallback === void 0) {
    fallback = '–';
  }
  if (options === void 0) {
    options = {
      useGrouping: true,
      maximumFractionDigits: 1
    };
  }
  if (!number) {
    return '-';
  }
  return new Intl.NumberFormat(locales, options).format(number);
};